// tslint:disable:object-literal-sort-keys
const ko = {
  translation: {
    usecases: "고객 사례",
    security: "보안",
    dashboard: "대시보드",
    product: "제품",
    api: "API",
    header: {
      home: "홈",
      product: "제품 소개",
      developers: "개발자 도구",
      dashboard: "대시보드",
      menus: {
        multisigWallet: "멀티시그 월렛",
        security: "보안",
        saveGasFee: "수수료 절감",
        dashboardAndAPI: "대시보드 & API",
        currencies: "지원 가상자산",
      },
    },
    usecaseExchangeServiceCard: {
      title: `멀티시그 지갑으로
입출금 시스템 보안을 강화하세요.`,
      mobileTitle: `멀티시그 지갑으로
입출금 시스템 보안을
강화하세요.`,
      name: `성태남 CTO, 플라이빗 `,
      description: `“멀티시그 지갑을 직접 개발하려고 하니 어려운 점이 많았어요.
헤네시스는 안전한 멀티시그 월렛을 이미 잘 갖추고 있었습니다.
헤네시스를 연동하여 ISMS 인증 심사 준비도 쉽게 할 수 있었습니다.”`,
      confirmButton: `고객 성공 사례 살펴보기`,
    },
    usecaseDAppServiceCard: {
      title: `지갑을 앱 안에 탑재하여
우수한 사용자 경험을 제공하세요.`,
      mobileTitle: `지갑을 앱 안에 탑재하여
우수한 사용자 경험을
제공하세요.`,
      name: `김경태 대표, 직토`,
      description: `“직토팀은 직접 지갑을 개발했다가 Henesis로 변경했습니다.
Henesis는 높은 수준의 보안장치를 지원하고, 서비스 운영에
편리한 대시보드까지 지원하는 게 가장 큰 장점입니다.”`,
      confirmButton: `고객 성공 사례 살펴보기`,
    },
    usecaseWalletServiceCard: {
      title: `이틀 만에 
안전한 지갑을 연동하세요`,
      mobileTitle: `이틀 만에 
안전한 지갑을 연동하세요`,
      name: `유재범 대표, 비트베리`,
      description: `“비트베리는 한국에서 가장 많은 사용자를 모은 지갑 서비스입니다.  
헤네시스 덕분에 지갑을 빠른 시일 내에 연동할 수 있었습니다.”`,
      confirmButton: `고객 성공 사례 살펴보기`,
    },
    usecaseExchange2ServiceCard: {
      title: `헤네시스 지갑으로 
가스비를 대폭 절감할 수 있었습니다`,
      mobileTitle: `헤네시스 지갑으로 
가스비를 대폭 절감할 수 있었습니다`,
      name: `윤영진 CTO, 플라이빗`,
      description: `“이더리움 가격과 가스비가 상승하면서 가스비 지출이 부담이었습니다.
헤네시스를 통해서 가스비를 대폭 절감할 수 있었습니다.”`,
      confirmButton: `고객 성공 사례 살펴보기`,
    },
    usecaseConsignmentServiceCard: {
      title: `One-Stop 지갑 솔루션으로 
디지털 자산 사업을 준비하세요`,
      mobileTitle: `One-Stop 지갑 솔루션으로 
디지털 자산 사업을 준비하세요`,
      name: `조진석  CISO, KODA`,
      description: `“KODA 팀은 Henesis 멀티시그 월렛을 활용해, 콜드월렛 시스템을 
구축했습니다. Henesis팀의 보안에 대한 전문성이 디지털 수탁 서비스를 
만드는 데에 큰 도움이 되었습니다.”`,
      confirmButton: `고객 성공 사례 살펴보기`,
    },
    usecasePaymentServiceCard: {
      title: `간편한 지갑 API를 연동해서
비트코인 간편 결제를 지원하세요`,
      mobileTitle: `간편한 지갑 API를 연동해서
비트코인 간편 결제를 지원하세요`,
      name: `김영일 팀장, 다날 핀테크 (페이코인)`,
      description: `“페이코인은 100만 유저를 대상으로 비트코인 간편 결제 서비스를 제공하며, 
그때 헤네시스 월렛을 사용하고 있습니다. 안전한 지갑을 빠른 시일에 도입할 
수 있다는 게 가장 큰 장점이었습니다.”`,
      confirmButton: `고객 성공 사례 살펴보기`,
    },
    multisigWalletCard: {
      title: `멀티 시그 지갑`,
      description: `Henesis 지갑은 총 3개의 키로 구성되며 트랜잭션 생성을 위해 
2개의 키로 서명되어야 합니다. 3개의 키는 각기 다른 보안 인프라
에서 관리되며 해커가 하나의 키를 탈취하더라도 디지털 자산을 인
출할 수 없습니다.`,
      confirmButton: `멀티시그 지갑 더 알아보기`,
    },
    authorityCard: {
      title: `권한 분리`,
      description: `Henesis에는 관리자(Admin), 출금 가능자(Spender), 조회 가
능자(Viewer) 3가지 권한이 존재합니다. 관리자는 팀원의 역할에 
맞게 권한을 부여하여 내부 통제 시스템을 구축할 수 있습니다.`,
      confirmButton: `조직 관리 더 알아보기`,
    },
    withdrawalPolicyCard: {
      item1: {
        title: `출금 한도`,
        description: `관리자는 1일, 1회 출금 한도를 설정할 수 있습니다.
한도 이상의 출금 요청시 관리자의 승인이 필요합니다.`,
      },
      item2: {
        title: `출금 주소 화이트리스트`,
        description: `지갑 별로 출금할 수 있는 주소를 제한할 수 있습니다. 
이를 통해 지갑 주소 입력 오류를 방지하고 내부 공모로 인한 
자산 유출을 통제할 수 있습니다.`,
      },
      confirmButton: `출금 정책 더 알아보기`,
    },
    networkSecurityCard: {
      item1: {
        title: `IP 주소 화이트리스트`,
        description: `허가된 IP 주소로 부터의 요청만 처리합니다. 허가되지 않은 
요청은 거절되며 관리자에게 경고 알림이 전달됩니다.`,
      },
      item2: {
        title: `Access Token`,
        description: `API 호출 시 Access Token을 통해 사용자 인증을합니다. 
권한에 따라 호출할 수 있는 API가 제한됩니다.`,
      },
      item3: {
        title: `API Secret`,
        description: `해커의 데이터 위변조 공격을 방지하기 위해 모든 통신에는 
API Secret를 활용한 HMAC 알고리즘을 도입하였습니다.`,
      },
      confirmButton: `네트워크 보안 더 알아보기`,
    },
    monitoringCard: {
      item1: {
        title: `정책 변경 알림`,
        description: `내부 규정에 맞지 않는 정책 변경은 해킹으로 이어질 수 있어 
보안 정책이 변경되었을 때 관리자에게 즉시 알림을 전송합니다. `,
      },
      item2: {
        title: `이상 행위 알림`,
        description: `정책을 위반하는 이상 행위가 감지되었을 때 관리자에게 경고 
메일을 전송합니다. 이상 행위 감지를 통해 해킹 시도를 사전에 
차단할 수 있습니다.`,
      },
      confirmButton: `모니터링 더 알아보기`,
    },
    serviceSection: {
      title: `가상자산을 쉽고 
빠르게 지원하세요`,
      description: `국내 주요 은행, 가상자산 거래소, 핀테크 회사, 가상자산 
수탁업체가 Henesis로 가상자산 서비스를 준비합니다. `,
      confirmButton: "상담 요청하기",
    },
    statisticsSection: {
      title: `지갑은 헤네시스에 맡기고,
서비스 본질에 집중하세요.`,
      costCaption: `인하우스 개발 대비 절감 비용`,
      days: "일",
      apiCaption: `API 연동에 걸리는 시간`,
      amount: "500억원+",
      amountCaption: `보관된 총 디지털 자산의 가치`,
    },
    usecasesSection: {
      walletTabLabel: "가상자산 지갑",
      exchange2TabLabel: "가상자산 거래소",
      consignmentTabLabel: "가상자산 수탁",
      paymentTabLabel: "비트코인 결제",
    },
    onestopSection: {
      title: `가상자산 서비스를 위한 
원스톱 솔루션`,
      multisigWallet: {
        title: "ISMS 인증을 위한 멀티 시그 지갑",
        description: `Henesis는 가상자산사업자용 ISMS 인증 취득에 
필요한 지갑 솔루션을 지원합니다.`,
      },
      supportWallet: {
        title: "이틀 만에 지갑 연동 지원",
        description: `Henesis를 이용하는 고객사는 평균 2일~2주 내에 
지갑 서비스를 연동하고 있습니다. `,
      },
      saveGasFees: {
        title: "연간 최대 95% 가스비 절감",
        description: `연간 450억을 가스비로 지출하는 글로벌 Top 10 거래소가 
가스비 최대 약 420억(95%)를 절약할 수 있습니다.`,
      },
    },
    securitySection: {
      title: `가장 안전한 
가상자산 지갑 솔루션`,
      learnMoreButton: `Henesis 더 알아보기`,
      multisigWallet: {
        title: "멀티 시그 지갑",
        description: `키를 여러 개로 분산하여 리스크를 낮추고
키 유실시 복구할 수 있습니다.`,
      },
      hackingGuard: {
        title: "해킹 방어",
        description: `IP 주소, 출금 주소 화이트리스팅, Access Token 인증, 
OTP 인증 등 강력한 보안 장치로 해킹 가능성을 차단합니다.`,
      },
      authSeperation: {
        title: "권한 분리",
        description: `기업 내 담당자 역할에 맞게 권한을 부여할 수 있고,
가상자산 지갑별로 출금한도를 설정할 수 있습니다. `,
      },
    },
    saveGasFeesSection: {
      title: `연간 최대 95% 가스비 절약`,
      description: `글로벌 Top 10 거래소 기준, 지출하고 있는 이더리움 가스비 대비 
연간 최대 420억까지 가스비를 절감할 수 있습니다. `,
      registerButton: `가스비 절감 컨설팅 신청하기`,
    },
    dashboardSection: {
      title: `모든 정보를 한눈에 보고
통제할 수 있는 컨트롤 타워`,
      description: `웹 대시보드를 통해 입출금 내역, 출금 승인 요청 등
지갑에 대한 모든 정보를 실시간으로 모니터링하세요.`,
      homepage: "대시보드 사용하기",
    },
    apiSection: {
      title: `디지털 자산을 연동하는
가장 강력하고 쉬운 API`,
      description: `개발자 친화적인 API를 통해 블록체인 지식 없이도
손쉽게 연동이 가능합니다.`,
      homepage: "API 연동하기",
    },
    customerSection: {
      title: `HAECHI LABS를 신뢰할 수 있는 이유`,
      description: `Henesis는 해치랩스 팀이 개발한 멀티시그 월렛 솔루션입니다. 
제1금융권부터 핀테크 회사, 가상 자산 거래소, 디지털 자산 수탁회사, 암호화폐 펀드까지 
Henesis로 디지털 자산을 안전하게 보관하고 있습니다.`,
      moreText: `고객사 더 보기`,
    },
    tryItSection: {
      title: "지금 바로 가장 안전한 지갑을 도입하세요",
      confirmButton: "상담 요청하기",
    },
    footer: {
      description: `사업자 등록번호 : 145-88-00918 | 대표: 김종호, 문건기
서울특별시 강남구 봉은사로 179 (논현동, H타워) 12층`,
    },
    productServiceSection: {
      title: `Henesis는 왜 안전할까요?`,
      description: `Henesis는 고객이 직접 자산을 안전하게 관리할 수 있게 돕는 멀티 시그 지갑 솔루션입니다. 
복잡한 블록체인 인프라 구축 없이 API 연동만으로 안전하고 편리하게 지갑 시스템을 구축할 수 있습니다. 
멀티 시그 트랜잭션을 생성하기 위해서는 고객사의 키로 1차 서명, Henesis 키로 2차 서명을 해야 합니다.`,
    },
    enterpriseGradeSecuritySection: {
      tabs: {
        multisig: `멀티 시그 지갑`,
        authority: `권한 분리`,
        withdrawalPolicy: `출금 정책`,
        networkSecurity: `네트워크 보안`,
        monitoring: `모니터링`,
      },
      title: `제 1 금융권 수준의 보안을 지원합니다`,
      description: `Henesis는 외부 해킹, 내부 공모 등으로부터 기업의 디지털 자산을 안전하게 지킵니다. 
멀티 시그 지갑, 네트워크 보안, 견고한 출금 정책 등의 다중 보안 시스템을 적용해 시장에서 가장 침투하기 어려운 시스템을 제공합니다.`,
    },
    transactionFeeManagementSection: {
      title: `수수료는 저렴하게, 수수료 관리는 편리하게`,
      item1: {
        title: `최대 95% 수수료 절감`,
        description: `이더리움 멀티 시그 스마트 컨트랙트 최적화를 통해, 막대한 운영 비용을 들이지 않고 대규모 입출금 시스템을 구축할 수 있습니다.`,
        linkText: `가스비 절감 더 알아보기`,
      },
      item2: {
        title: `수수료 지갑`,
        description: `더 이상 트랜잭션 생성을 위해 수수료 관리를 직접할 필요가 없습니다.
수수료 지갑에 예치된 자산으로 모든 트랜잭션 수수료를 납부합니다.`,
        linkText: `수수료 지갑 더 알아보기`,
      },
    },
    productSaveGasFeesSection: {
      title: `지금 바로 가스비 95%를 절감하세요`,
      confirmButton: `상담 요청하기`,
    },
    dashboardAndAPISection: {
      title: `연동은 쉽게, 관리는 편하게`,
      dashboard: {
        subTitle: `대시보드`,
        linkText: `대시보드 사용하기`,
        item1: {
          title: `모든 가상자산 현황을 
손쉽게 관리하세요.`,
          description: `대시보드를 통해 가상자산의 입출금, 보유량을 확인하고 
권한, 보안 기능 설정 등 지갑 관련 모든 업무를 지원합니다.`,
        },
        item2: {
          title: `마스터 지갑 생성`,
          description: `지갑 비밀번호 설정만으로 손쉽게 멀티 시그 지갑을 생성할 수 있으며, 지갑 생성 시 재난 복구를 위한 복구 키트를 제공합니다.`,
        },
        item3: {
          title: `입출금 내역`,
          description: `입금, 출금 트랜잭션을 실시간으로 모니터링할 수 있습니다. 
트랜잭션의 상태를 확인하여 송금이 완료되었는지 확인하세요.`,
        },
        item4: {
          title: `출금 화면`,
          description: `지갑 비밀번호, OTP 코드를 입력하여 대시보드를 통해서도 
안전하게 디지털 자산을 이체를 할 수 있습니다.`,
        },
        item5: {
          title: `수수료 내역`,
          description: `지갑에서 발생한 모든 트랜잭션 수수료 사용 내역을 한눈에 
살펴볼 수 있고, 회계 감사를 위한 증빙 자료로 수수료 사용 
내역을 다운로드할 수 있습니다.`,
        },
      },
      api: {
        subTitle: `API`,
        title: `환경에 구애 받지 않고 
비즈니스 로직에만 집중하세요`,
        description: `개발자 친화적인 API를 통해 블록체인 지식 없이도 
손쉽게 연동할 수 있습니다.`,
        linkText: `API 문서 더 알아보기`,
      },
    },
    blockchainSection: {
      title: `다양한 블록체인 지원`,
      description: `Henesis는 현재 6개의 블록체인 프로토콜과 300개 이상의 코인을 지원하고 있습니다. 
매월 새로운 블록체인과 코인을 추가하고 있습니다.`,
      blockchain: {
        btc: `비트코인 
(BTC)`,
        eth: `이더리움 
(ETH)`,
        klay: `클레이튼 
(KLAY)`,
        fil: `파일코인 
(FIL)`,
        ltc: `라이트 코인 
(LTC)`,
        bch: `비트코인 캐시 
(BCH)`,
        bsc: `바이낸스 스마트 체인 
(BSC)`,
        others: `추후 다양한 메인넷 지원 예정`,
      },
    },
    requestAudit: "보안감사 문의",
  },
};

export default ko;
